import React, { useEffect, useState } from 'react'
import { getsessionStorage, getStorage, validateFunctionalForm } from '../../utils';
import { citySearch, employementTypeList, functionalAreaList, jobRoleList, salaryList } from '../../action/jobs';
import NumberFormat from 'react-number-format';
import { Select } from 'antd';
import { Typeahead } from 'react-bootstrap-typeahead';
import constant from '../../constant';
import { registeredCampusDrive } from '../../action/campusDrive';

const StepOne = ({ styles, detail, onSubmit, company_name }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [state, setState] = useState({
        oppurtunity_type: {
            name: "oppurtunity_type",
            value: detail ? detail.OPPURTUNITY_TYPE : "JOB",
            error: "",
            isRequired: true,
        },
        campus_drive: {
            name: "campus_drive",
            value: detail?.DRIVE_ID || "",
            options: [],
            error: "",
            isRequired: false,
        },
        job_title: {
            name: "job_title",
            value: detail ? detail.JOB_TITLE : "",
            error: "",
            isRequired: true,
        },
        employment_type: {
            name: "employment_type",
            value: detail ? detail.EMPLOYMENT_TYPE_ID : "",
            options: [],
            error: "",
            isRequired: true,
        },
        no_of_vacancies: {
            name: "no_of_vacancies",
            value: detail ? detail.NO_OF_VACANCIES : "",
            error: "",
            isRequired: true,
        },
        ctc_min: {
            name: "ctc_min",
            value: detail ? detail.CTC_MIN : "",
            options: [],
            error: "",
            isRequired: true,
        },
        ctc_max: {
            name: "ctc_max",
            value: detail ? detail.CTC_MAX : "",
            options: [],
            error: "",
            isRequired: true,
        },
        is_salary_hide_from_candidate: detail && detail.IS_HIDE_SALARY_FROM_CANDIDATE === "Y",
        is_work_from_home: detail && detail.IS_WORK_FROM_HOME === "Y",
        is_field_job: detail && detail.IS_FIELD_JOB === "Y",
        work_from_home_type: {
            name: "work_from_home_type",
            value: detail && detail.TYPE_OF_WORK_FROM_HOME === "WFHDC" ? "DURING_COVID" : detail && detail.TYPE_OF_WORK_FROM_HOME === "PRJ" ? "PERMANENT" : "",
            error: "",
            isRequired: false,
        },
        functional_area: {
            name: "functional_area",
            value: detail ? detail.FUNCTIONAL_AREA_ID : "",
            options: [],
            error: "",
            isRequired: true,
        },
        city: {
            name: "city",
            value: detail ? detail.CITY_ID : [],
            options: [],
            error: "",
            isRequired: true,
        },

        job_role: {
            name: "job_role",
            value: detail ? String(detail.ROLE_ID) : "",
            options: [],
            error: "",
            isRequired: true,
        },
        selected_city: detail ? detail.CITY_ID : [],
        is_this_for_client: detail?.CLIENT_NAME ? true : false,
        client_name: {
            name: "client_name",
            value: detail ? detail.CLIENT_NAME : "",
            error: "",
            isRequired: false,
        },
        client_details: {
            name: "client_details",
            value: detail ? detail.CLIENT_DETAILS : "",
            error: "",
            isRequired: false,
        },
        company_name: {
            name: "company_name",
            value: detail ? detail.COMPANY_NAME : "",
            options: [],
            error: "",
            isRequired: false,
        },
        address: {
            name: "address",
            value: detail ? detail.ADDRESS : "",
            options: [],
            error: "",
            isRequired: false,
        },
    });
    useEffect(() => {
        if (detail) {
            setState((prevState) => ({
                ...prevState,
                job_title: {
                    ...prevState.job_title,
                    value: detail.JOB_TITLE || "",
                },
                employment_type: {
                    ...prevState.employment_type,
                    value: detail.EMPLOYMENT_TYPE_ID || "",
                },
                no_of_vacancies: {
                    ...prevState.no_of_vacancies,
                    value: detail.NO_OF_VACANCIES || "",
                },
                ctc_min: {
                    ...prevState.ctc_min,
                    value: detail.CTC_MIN || "",
                },
                ctc_max: {
                    ...prevState.ctc_max,
                    value: detail.CTC_MAX || "",
                },
                is_salary_hide_from_candidate: detail.IS_HIDE_SALARY_FROM_CANDIDATE === "Y",
                is_work_from_home: detail.IS_WORK_FROM_HOME === "Y",
                is_field_job: detail.IS_FIELD_JOB === "Y",
                work_from_home_type: {
                    ...prevState.work_from_home_type,
                    value:
                        detail.TYPE_OF_WORK_FROM_HOME === "WFHDC"
                            ? "DURING_COVID"
                            : detail.TYPE_OF_WORK_FROM_HOME === "PRJ"
                                ? "PERMANENT"
                                : "",
                },
                functional_area: {
                    ...prevState.functional_area,
                    value: detail.FUNCTIONAL_AREA_ID || "",
                },
                city: {
                    ...prevState.city,
                    value: detail.CITY_ID || [],
                },
                company_name: {
                    ...prevState.company_name,
                    value: detail.COMPANY_NAME || "",
                },
                address: {
                    ...prevState.address,
                    value: detail.ADDRESS || "",
                },
                job_role: {
                    ...prevState.job_role,
                    value: String(detail.ROLE_ID) || "",
                },
                selected_city: detail.CITY_ID || [],
            }));
        }
    }, [detail]);
    useEffect(() => {
        if (detail?.FUNCTIONAL_AREA_ID) {
            const functionalAreaId = detail.FUNCTIONAL_AREA_ID;
            jobRoleList(functionalAreaId).then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        job_role: {
                            ...prevState.job_role,
                            options: res.result,
                        },
                    }));
                } else {
                    console.error(res.error)
                }
            });
        }

        employementTypeList()
            .then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        employment_type: {
                            ...prevState.employment_type,
                            options: res.result,
                        },
                    }));
                } else {
                    console.error(res.error);
                }
            })
            .catch((err) => {
                console.error(err);
            });

        salaryList()
            .then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        ctc_min: {
                            ...prevState.ctc_min,
                            options: res.result,
                        },
                        ctc_max: {
                            ...prevState.ctc_max,
                            options: res.result,
                        }
                    }));
                } else {
                    console.error(res.error);
                }
            })
            .catch((err) => {
                console.error(err);
            });

        functionalAreaList()
            .then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        functional_area: {
                            ...prevState.functional_area,
                            options: res.result,
                        },
                    }));
                } else {
                    console.error(res.error);
                }
            })
            .catch((err) => {
                console.error(err);
            });

        registeredCampusDrive().then((res) => {
            if (res.status) {
                debugger
                setState((prevState) => ({
                    ...prevState,
                    campus_drive: {
                        ...prevState.campus_drive,
                        options: res.result.list,
                    },
                }));
            } else {
                console.error(res.error);
            }
        })
            .catch((err) => {
                console.error(err);
            });
    }, []);


    const onCitySearch = (value) => {
        citySearch(value).then((res) => {
            if (res.status) {
                setState((prevState) => ({
                    ...prevState,
                    city: {
                        ...prevState.city,
                        options: res.result,
                    },
                }));
            } else {
                alert(res.error);
            }
        });
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
            }
        }));

        if (name === 'functional_area') {
            jobRoleList(value).then((res) => {
                if (res.status) {
                    setState((prevState) => ({
                        ...prevState,
                        job_role: {
                            ...prevState.job_role,
                            options: res.result,
                        },
                    }));
                } else {
                    console.error(res.error)
                }
            });
        }
    };
    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     const { is_work_from_home, work_from_home_type } = state;


    //     if (validateFunctionalForm(state, setState)) {
    //         const model = {
    //             OPPURTUNITY_TYPE: state.oppurtunity_type.value,
    //             JOB_TITLE: state.job_title.value,
    //             NO_OF_VACANCIES: state.no_of_vacancies.value,
    //             EMPLOYMENT_TYPE_ID: state.employment_type.value,
    //             IS_FIELD_JOB: state.is_field_job ? 'Y' : 'N',
    //             IS_WORK_FROM_HOME: is_work_from_home ? "Y" : "N",
    //             IS_WORK_FROM_HOME_DURING_COVID: is_work_from_home && work_from_home_type.value === "DURING_COVID" ? "Y" : "N",
    //             TYPE_OF_WORK_FROM_HOME: is_work_from_home && work_from_home_type.value === "DURING_COVID" ? "WFHDC" : is_work_from_home && work_from_home_type.value === "PERMANENT" ? "PRJ" : "",
    //             CTC_CURRENCY: 1,
    //             CTC_MIN: state.ctc_min.value,
    //             CTC_MAX: state.ctc_max.value,
    //             IS_HIDE_SALARY_FROM_CANDIDATE: state.is_salary_hide_from_candidate,
    //             FUNCTIONAL_AREA_ID: state.functional_area.value,
    //             ROLE_ID: state.job_role.value,
    //             ADDRESS: state.address.value,
    //             COMPANY_NAME: state.is_this_for_client ? state.company_name.value : company_name,
    //             CITY_ID: state.city.value,
    //             IS_THIS_FOR_CLIENT: state.is_this_for_client,
    //             CLIENT_NAME: state.is_this_for_client ? state.client_name.value : '',
    //             CLIENT_DETAILS: state.is_this_for_client ? state.client_details.value : '',

    //         };
    //         const storage = getsessionStorage(constant.keys.jobPostingSession);

    //         if (storage?.id) {
    //             model.JOB_ID = storage?.id;
    //         }

    //         onSubmit(model);
    //     }
    // };
    const handleSubmit = (e) => {
        e.preventDefault(); // Ensure default form submission is prevented immediately

        if (isSubmitting) return; // Prevent multiple clicks

        setIsSubmitting(true);

        try {
            const { is_work_from_home, work_from_home_type } = state;

            if (validateFunctionalForm(state, setState)) {
                const model = {
                    OPPURTUNITY_TYPE: state.oppurtunity_type.value,
                    DRIVE_ID: state.campus_drive.value,
                    JOB_TITLE: state.job_title.value,
                    NO_OF_VACANCIES: state.no_of_vacancies.value,
                    EMPLOYMENT_TYPE_ID: state.employment_type.value,
                    IS_FIELD_JOB: state.is_field_job ? 'Y' : 'N',
                    IS_WORK_FROM_HOME: is_work_from_home ? "Y" : "N",
                    IS_WORK_FROM_HOME_DURING_COVID:
                        is_work_from_home && work_from_home_type.value === "DURING_COVID" ? "Y" : "N",
                    TYPE_OF_WORK_FROM_HOME:
                        is_work_from_home && work_from_home_type.value === "DURING_COVID"
                            ? "WFHDC"
                            : is_work_from_home && work_from_home_type.value === "PERMANENT"
                                ? "PRJ"
                                : "",
                    CTC_CURRENCY: 1,
                    CTC_MIN: state.ctc_min.value,
                    CTC_MAX: state.ctc_max.value,
                    IS_HIDE_SALARY_FROM_CANDIDATE: state.is_salary_hide_from_candidate,
                    FUNCTIONAL_AREA_ID: state.functional_area.value,
                    ROLE_ID: state.job_role.value,
                    ADDRESS: state.address.value,
                    COMPANY_NAME: state.is_this_for_client ? state.company_name.value : company_name,
                    CITY_ID: state.city.value,
                    IS_THIS_FOR_CLIENT: state.is_this_for_client,
                    CLIENT_NAME: state.is_this_for_client ? state.client_name.value : '',
                    CLIENT_DETAILS: state.is_this_for_client ? state.client_details.value : '',
                };

                const storage = getsessionStorage(constant.keys.jobPostingSession);
                if (storage?.id) {
                    model.JOB_ID = storage?.id;
                }

                onSubmit(model).finally(() => setIsSubmitting(false)); // Ensure state is reset only after API call
            } else {
                setIsSubmitting(false); // Reset if validation fails
            }
        } catch (error) {
            console.error("Error submitting job:", error);
            setIsSubmitting(false); // Reset if there's an error
        }
    };




    return (
        <React.Fragment>
            <div>
                <div className="card border-0 shadow-sm rounded-3 mb-3">
                    <div className={`${styles['bgblue-ctm']} text-white`}>
                        <h5>Requirement Details</h5>
                        <p className="mb-0">We use this information to find the best candidates for the requirement.</p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Type of Requirement <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <select
                                            className={state.oppurtunity_type.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.oppurtunity_type.name}
                                            value={state.oppurtunity_type.value}
                                            onChange={handleChange}
                                        >
                                            <option value={'JOB'}>Job</option>
                                            <option value={'INTERNSHIP'}>Internship</option>
                                            <option value={'CAMPUS_EXCLUSIVE'}>Campus Exlusive</option>
                                            <option value={'CAMPUS_DRIVE'}>Campus Drive</option>
                                        </select>

                                    </div>
                                </div>
                            </div>
                            {state.oppurtunity_type.value == 'CAMPUS_DRIVE' && <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Campus Drive <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <select
                                            className={state.campus_drive.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.campus_drive.name}
                                            value={state.campus_drive.value}
                                            onChange={handleChange}
                                        >
                                            <option value={''}>Select Drive</option>
                                            {state.campus_drive.options?.map((item) => {
                                                return (
                                                    <option value={item.DRIVE_ID}>{item.DRIVE_NAME}</option>

                                                )
                                            })}
                                        </select>

                                    </div>
                                </div>
                            </div>}
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Designation <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <input
                                            className={state.job_title.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            type="text"
                                            placeholder="Mention the designation or role"
                                            name={state.job_title.name}
                                            value={state.job_title.value}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>No of Vacancies <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <NumberFormat
                                            className={state.no_of_vacancies.error.length > 0 ? "form-control is-invalid sq-db5" : "form-control sq-db5"}
                                            name={state.no_of_vacancies.name}
                                            value={state.no_of_vacancies.value}
                                            onChange={handleChange}
                                            placeholder="Vacancies"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}> Functional Area <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <select
                                            className={state.functional_area.error.length > 0 ? "form-select is-invalid" : "form-select"}
                                            name={state.functional_area.name}
                                            value={state.functional_area.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">
                                                Choose a functional area for your job
                                            </option>
                                            {state.functional_area.options.length > 0 &&
                                                state.functional_area.options.map((item, index) => (
                                                    <option key={index} value={item.FUNCTIONAL_AREA_ID}>
                                                        {item.FUNCTIONAL_AREA}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}> Role <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <Select
                                            className={state.job_role.error.length > 0 ? "is-invalid" : ""}
                                            placeholder="Select Job Role"
                                            onChange={(e) => {
                                                const available = state.job_role.options.find(item => item.ROLE_NAME.toLowerCase() === (e.length > 0 ? e[e.length - 1].toLowerCase() : ""));
                                                if (available) {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        job_role: {
                                                            ...prevState.job_role,
                                                            value: available.ROLE_ID,
                                                        }
                                                    }));
                                                } else {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        job_role: {
                                                            ...prevState.job_role,
                                                            value: e.length > 0 ? e[e.length - 1] : ""
                                                        }
                                                    }));
                                                }
                                            }}
                                            mode="tags"
                                            value={state.job_role.value.length > 0 ? state.job_role.value : undefined}
                                            notFoundContent=""
                                        >
                                            {state.job_role.options.length > 0 &&
                                                state.job_role.options.map((item, index) => (
                                                    <Select.Option key={index} value={item.ROLE_ID.toString()}>
                                                        {item.ROLE_NAME}
                                                    </Select.Option>
                                                ))}
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}> Employment Type <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <select
                                            className={state.employment_type.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                            name={state.employment_type.name}
                                            value={state.employment_type.value}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Employment Type</option>
                                            {state.employment_type.options.length > 0 &&
                                                state.employment_type.options.map((item, index) => (
                                                    <option key={index} value={item.EMPLOYMENT_TYPE_ID}>
                                                        {item.EMPLOYMENT_TYPE}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div className="card border-0 shadow-sm rounded03">
                    <div className={`${styles['bgblue-ctm']} text-white`}>
                        <h5>Location</h5>
                        <p className="mb-0">Let candidates know where they will be working from.</p>
                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Work location type <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <ul className={`${styles['post-joblist']} d-flex`}>
                                            <li>
                                                <input
                                                    type="radio"
                                                    checked={!state.is_work_from_home && !state.is_field_job}
                                                    onClick={() =>
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            is_work_from_home: false,
                                                            is_field_job: false,
                                                        }))
                                                    }
                                                />
                                                <div className="wfhheading">
                                                    Work from Office
                                                    <p>Candidate will work from the office</p>
                                                </div>
                                            </li>
                                            <li>
                                                <input
                                                    type="radio"
                                                    checked={
                                                        state.is_work_from_home && state.work_from_home_type.value === "DURING_COVID"
                                                    }
                                                    onClick={() =>
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            is_work_from_home: true,
                                                            is_field_job: false,
                                                            work_from_home_type: { value: "DURING_COVID" },
                                                        }))
                                                    }
                                                />
                                                <div className="wfhheading">
                                                    Temporary Work From Home (Hybrid)
                                                    <p>Candidate will work from home or office based on company requirements</p>
                                                </div>
                                            </li>
                                            <li>
                                                <input
                                                    type="radio"
                                                    checked={
                                                        state.is_work_from_home && state.work_from_home_type.value === "PERMANENT"
                                                    }
                                                    onClick={() =>
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            is_work_from_home: true,
                                                            is_field_job: false,
                                                            work_from_home_type: { value: "PERMANENT" },
                                                        }))
                                                    }
                                                />
                                                <div className="wfhheading">
                                                    Permanent Remote
                                                    <p>Candidate can permanently work from home</p>
                                                </div>
                                            </li>
                                            <li>
                                                <input
                                                    type="radio"
                                                    checked={state.is_field_job && !state.is_work_from_home}
                                                    onClick={() =>
                                                        setState((prevState) => ({
                                                            ...prevState,
                                                            is_field_job: true,
                                                            is_work_from_home: false,
                                                        }))
                                                    }
                                                />
                                                <div className="wfhheading">
                                                    Field Job
                                                    <p>Candidate will need to be on the field for their job</p>
                                                </div>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>Location <span className="text-danger">*</span></label>
                                    <div className="d-flex flex-wrap gap-2">
                                        <div className="w-100 form-group sq-bd1">
                                            <Typeahead
                                                id="ta-location-ids"
                                                allowNew={false}
                                                labelKey={(option) => `${option.CITY}`}
                                                selected={state.city.value}
                                                multiple={true}
                                                options={state.city.options}
                                                onChange={(e) => {
                                                    setState(prevState => ({
                                                        ...prevState,
                                                        city: {
                                                            ...prevState.city,
                                                            value: e,
                                                        }
                                                    }));
                                                }}
                                                onInputChange={(e) => onCitySearch(e)}
                                                onKeyDown={(e) => {
                                                    if (e.code === 'Enter') {
                                                        let arg = [...state.city.value];
                                                        let available = state.city.options.find(item => item.city.toLowerCase() === e.target.value.toLowerCase());
                                                        let existed = arg.find(item => item.city.toLowerCase() === e.target.value.toLowerCase());
                                                        if (available && !existed) {
                                                            setState(prevState => ({
                                                                ...prevState,
                                                                city: {
                                                                    ...prevState.city,
                                                                    value: [...arg, available],
                                                                }
                                                            }));
                                                        }
                                                    }
                                                }}
                                                placeholder="Search and add new locations"
                                                emptyLabel
                                                className={state.city.error.length > 0 ? "errorMsg" : ""}
                                            />
                                        </div>
                                        {state.city.value.map((item, index) => (
                                            <span key={index} className="locationbox sq-bd1">
                                                {item.CITY}
                                                <i
                                                    onClick={() => {
                                                        const updatedCities = state.city.value.filter((i) => i.CITY !== item.CITY);
                                                        setState(prevState => ({
                                                            ...prevState,
                                                            city: {
                                                                ...prevState.city,
                                                                value: updatedCities
                                                            }
                                                        }));
                                                    }}
                                                    className="fa fa-close sq-bd1"
                                                ></i>
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded03">
                    <div className={`${styles['bgblue-ctm']} text-white`}>
                        <h5>
                            {state?.oppurtunity_type?.value === 'JOB' ? 'Compensation' : 'Stipend'}
                        </h5>
                        <p className="mb-0">
                            Job postings with the right {state?.oppurtunity_type?.value === 'JOB' ? 'salary' : 'stipend'} will help you find the right candidates.
                        </p>

                    </div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="mb-3">
                                    <label className={`${styles['ct-form-label']} form-label`}>
                                        {state?.oppurtunity_type?.value === 'JOB'
                                            ? 'Annual Salary Range (in Lakhs)'
                                            : 'Monthly Stipend Range (in ₹)'}{" "}
                                        <span className="text-danger">*</span>
                                    </label>

                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <select
                                                className={state.ctc_min.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.ctc_min.name}
                                                value={state.ctc_min.value}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    {state?.oppurtunity_type?.value === 'JOB'
                                                        ? 'Min Annual Salary'
                                                        : 'Min Monthly Stipend'}

                                                </option>
                                                {state.ctc_min.options.length > 0 &&
                                                    state.ctc_min.options.map((item, index) => (
                                                        <option key={index} value={item.SALARY}>
                                                            {item.SALARY_DETAILS}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className='col-md-6'>
                                            <select
                                                className={state.ctc_max.error.length > 0 ? "form-control is-invalid" : "form-control"}
                                                name={state.ctc_max.name}
                                                value={state.ctc_max.value}
                                                onChange={handleChange}
                                            >
                                                <option value="">
                                                    {state?.oppurtunity_type?.value === 'JOB'
                                                        ? 'Max Annual Salary'
                                                        : 'Max Monthly Stipend'}

                                                </option>
                                                {state.ctc_max.options.length > 0 &&
                                                    state.ctc_max.options.map((item, index) => {
                                                        if (Number(item.SALARY) >= Number(state.ctc_min.value))
                                                            return (
                                                                <option key={index} value={item.SALARY}>
                                                                    {item.SALARY_DETAILS}
                                                                </option>
                                                            );
                                                    })}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="checkbox"
                                        checked={state.is_salary_hide_from_candidate}
                                        onClick={() =>
                                            setState(prevState => ({
                                                ...prevState,
                                                is_salary_hide_from_candidate: !prevState.is_salary_hide_from_candidate,
                                            }))
                                        }
                                    />
                                    Hide salary details from candidates
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card border-0 shadow-sm rounded03">
                    <div className={`${styles['bgblue-ctm']} text-white`}>
                        <h5>
                            <input
                                className='me-2'
                                type="checkbox"
                                checked={state.is_this_for_client}
                                onChange={() =>
                                    setState(prevState => ({
                                        ...prevState,
                                        is_this_for_client: !prevState.is_this_for_client,
                                    }))
                                }
                            />
                            Is this job for a client?
                        </h5>
                        <p className="mb-0">Providing clear client details helps build trust and ensures the right candidates apply.</p>
                    </div>
                    {state.is_this_for_client &&
                        <React.Fragment>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="mb-3">

                                            <div className="row">
                                                <div className="col-md-4">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Company Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        name="company_name"
                                                        value={state.company_name.value}
                                                        placeholder="Mention Company Name"
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                                <div className="col-md-4">
                                                    <label className={`${styles['ct-form-label']} form-label`}>
                                                        Client Name <span className="text-danger">*</span>
                                                    </label>
                                                    <input
                                                        className="form-control"
                                                        type="text"
                                                        name="client_name"
                                                        value={state.client_name.value}
                                                        onChange={handleChange}
                                                        placeholder="Enter the client name"
                                                    />
                                                </div>

                                            </div>
                                            <div className="mb-4">
                                                <label className={`${styles['ct-form-label']} form-label`}>
                                                    Client Address <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    className="form-control"
                                                    type="text"
                                                    name="address"
                                                    value={state.address.value}
                                                    onChange={handleChange}
                                                    placeholder="Office address / landmark"
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <label className={`${styles['ct-form-label']} form-label`}>
                                                Client Details <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                name="client_details"
                                                value={state.client_details.value}
                                                onChange={handleChange}
                                                placeholder="Client Details"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </React.Fragment>

                    }
                </div>


            </div>
            <div className="d-flex justify-content-end mt-4">

                <button
                    className={`${styles['btn-next']} btn`}

                    onClick={handleSubmit}
                >
                    Next
                </button>
            </div>
        </React.Fragment>
    )
}

export default StepOne